module.exports = __webpack_public_path__ + "img/picture_03.99d1cd55.png";